import { AlertTriangle } from 'lucide-react'
import { buildPlanReadiness } from '@/lib/planReadiness'
import { Button } from '@/components/ui/button'

// Every item this panel can raise today is "cash balance is switched on but has
// no credit entered", so it says that instead of narrating a severity taxonomy.
// The list items are already imperative, so they carry no status chip: an
// "Unavailable" badge next to "Add a benefit credit" is a second way of saying
// the same thing.
export function PlanReadinessSummary({ plan, planLabel = 'Plan', onNavigate }) {
  const readiness = buildPlanReadiness(plan)
  if (!readiness.items.length) return null
  return (
    <section id="plan-readiness-summary" className="rounded-lg border border-amber-300 bg-amber-50/70 p-4 text-amber-950">
      <div className="flex items-start gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
        <div className="min-w-0 flex-1">
          <h3 className="text-sm font-semibold">Finish the cash-balance setup for {planLabel}</h3>
          <p className="mt-1 text-xs leading-relaxed">
            The cash-balance numbers stay blank until this is done.
          </p>
        </div>
      </div>
      <ul className="mt-3 space-y-2">
        {readiness.items.map((item) => (
          <li key={item.code} className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs">
            <span className="min-w-0 flex-1">{item.message}</span>
            {item.path && onNavigate && <Button type="button" size="sm" variant="outline" className="h-7 bg-background text-xs" onClick={() => onNavigate(item.path)}>Review</Button>}
          </li>
        ))}
      </ul>
    </section>
  )
}
